
const digest = '3c620efa8968a05583284c55b0d7f27ad8d3433b39ebf56eb2bd046cf359612b';
const classes = {"form":"_form_1cg3y_1","disabledForm":"_disabledForm_1cg3y_5","errorMessage":"_errorMessage_1cg3y_9"};
const css = `._form_1cg3y_1 {
  padding: 16px;
}

._disabledForm_1cg3y_5 {
  filter: blur(2px);
}

._errorMessage_1cg3y_9 {
  margin-bottom: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  